export default class NavMenu {
    constructor(){
        this.init()
    }
    init(){
        this.oldscroll = window.scrollY;
        this.didscroll = false;
        this.back2Top = document.getElementById('back-to-top');
        window.onscroll = ()=>this.didscroll = true;
        setInterval(()=>{
            if(this.didscroll){
                this.didscroll = false;
                this.scroll();
            }
        }, 25);
        this.nav = document.getElementById('main-nav');
        this.checkFloating();
    }
    checkFloating(){
        this.oldscroll = window.scrollY;
        if(this.nav.classList.contains('fixed')){
            if(this.oldscroll > 50) {
                this.nav.classList.add('floating');
            }
        } else if (parseInt(this.nav.style.top, 10) > 0)
            this.nav.classList.add('floating');
    }
    findParentDropdown(el){
        let parent = el;
        do {
            parent = parent.parentElement;
        } while(!parent.classList.contains('dropdown'));
        return parent;
    }
    toggleFocus(e){
        let p = e.parentElement;
        if(p.classList.contains('active')){
            p.classList.remove('active')
        } else {
            p.classList.add('active');

        }
    }
    linkFocus(){
        this.findParentDropdown(document.activeElement).classList.add('open');
    }
    linkBlur(el){
        let dropdown = this.findParentDropdown(el);
        setTimeout(el=>{
            if(!dropdown.querySelector(':focus')){
                dropdown.classList.remove('open');
            }
        }, 25);
    }
    menuToggle(){
        let menu = document.querySelector('nav#main-nav .menu');
        menu.classList.toggle('active');
        if(menu.classList.contains('active')){
            this.nav.classList.add('fixed');
            this.nav.classList.remove('scrolling');
            this.nav.style.top = 0;

        } else {
            if(window.scrollY > 0) this.nav.classList.add('floating');
        }
    }
    scroll(){
        let scrollY = window.scrollY;
        let scrollDir = this.oldscroll - scrollY;
        let shadowHeight = 30;
        if(scrollY > window.innerHeight * 1.5){
            this.back2Top.classList.remove('hidden');
            if(scrollY + window.innerHeight > document.querySelector('.main.content').offsetHeight - 207){
                this.back2Top.classList.add('at-bottom');
            } else {
                this.back2Top.classList.remove('at-bottom');
            }
        } else {
            this.back2Top.classList.add('hidden');
            this.back2Top.classList.remove('at-bottom');
        }
        if(scrollDir !== 0 && !this.nav.querySelector('.menu').classList.contains('active')){
            this.oldscroll = scrollY;
            if(scrollDir > 0){ //Scrolling up
                if(scrollY <= 0){
                    this.nav.classList.remove('fixed');
                    this.nav.classList.add('scrolling');
                    this.nav.classList.remove('floating');
                    this.nav.style.top = 0;
                } else if(!this.nav.classList.contains('fixed')){
                    if(this.nav.classList.contains('scrolling')){
                        if(scrollY <= this.nav.offsetTop){
                            this.nav.classList.add('fixed');
                            this.nav.classList.remove('scrolling');
                            this.nav.style.top = 0;
                        } else if(this.nav.classList.contains('scrolling') && scrollY > this.nav.offsetTop + this.nav.clientHeight + shadowHeight + 50) {
                            this.nav.classList.remove('scrolling');
                            this.nav.style.top = 0;
                            this.nav.classList.add('floating');
                        }
                    } else {
                        let top = (scrollY - this.nav.clientHeight - shadowHeight);
                        if(top < 50) top = 0;
                        this.nav.style.top = top + 'px';
                        this.nav.classList.add('scrolling');
                    }
                }
            } else { // Scrolling down
                if(this.nav.classList.contains('fixed')){
                    this.nav.classList.remove('fixed');
                    this.nav.style.top = scrollY + 'px';
                    this.nav.classList.add('scrolling');
                } else if(this.nav.classList.contains('scrolling') && scrollY > this.nav.offsetTop + this.nav.clientHeight + shadowHeight + 50) {
                    this.nav.classList.remove('scrolling');
                    this.nav.style.top = 0;
                    this.nav.classList.add('floating');
                }
            }
            if(window.searchScroll) window.searchScroll();
        }
    }
    searchOpen(link){
        let form = link.parentElement.querySelector('form');
        link.setAttribute('hidden','');
        form.removeAttribute('hidden');
        form.querySelector('input').focus();
    }
    searchCollapse(input){
        if(input.value === ''){
            let form = input.parentElement;
            let link = form.parentElement.querySelector('a');
            form.setAttribute('hidden','');
            link.removeAttribute('hidden');
        }
    }
    search(event, form){
        event.preventDefault();

    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Nav Menu.js